export const SOCKET_IO = process.env.VUE_APP_SOCKET_IO || 'http://localhost:3200';
